import * as actionTypes from "../actionTypes";
const initial = {
  loading: false,
  modal_loading: false,
  popupMessages: { mode: false, message: "", color: "" },
  refresh: 1,
  letRefresh: true,
  multi_server_url: localStorage.MULTI_SERVER_URL || "",
};

export const generalReducer = (state = initial, action) => {
  let ret = "";
  switch (action.type) {
    case actionTypes.LOADING:
      ret = "loading";
      break;
    case actionTypes.MULTI_SERVER_URL:
      ret = "multi_server_url";
      break;
    case actionTypes.MODAL_LOADING:
      ret = "modal_loading";
      break;
    case actionTypes.MESSAGES:
      ret = "popupMessages";
      break;
    case actionTypes.REFRESH:
      ret = "refresh";
      break;
    case actionTypes.LET_REFRESH:
      ret = "letRefresh";
      break;

    default:
      return state;
  }

  return { ...state, [ret]: action.payload };
};
